'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GenericForm;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _generic = require('../../generic');

var _generic2 = _interopRequireDefault(_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GenericForm(props) {
  return !props.fieldErrors || props.fieldErrors.isEmpty() ? _react2.default.createElement(_generic2.default, props) : null;
}

GenericForm.propTypes = {
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  }))
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/generic-form/components/GenericForm.component.js
// module id = 1491
// module chunks = 1